import type { ReactNode } from 'react';
import { cn } from '../_lib/utils';
import type { SanityImage } from '../types';
import { isValidRichText } from '../_lib/isValidRichText';

import { Anchor, type LinkShape } from '../Anchor';
import { IconResolver } from '../IconResolver';
import { Media } from '../Media';
import { Text } from '../Text';

export type LocationProps = {
	address: ReactNode;
	className?: string;
	image?: SanityImage;
	link?: LinkShape;
	title?: string;
};

export function Location(props: LocationProps) {
	return (
		<article
			className={cn(
				'grid gap-spacing-md sm:grid-cols-[1fr_6rem] py-spacing-md lg:max-xl:grid-cols-1 xl:grid-cols-[1fr_13.75rem]',
				props.className,
			)}
			data-component='Location'
		>
			<div className={`grid gap-spacing-5xs`}>
				{props.title && (
					<Text as='h2' styleType='body-xl-semibold'>
						{props.title}
					</Text>
				)}
				{isValidRichText(props.address) && (
					<Text as='address' className={`text-text-secondary not-italic whitespace-pre`} styleType='body-lg'>
						{props.address}
					</Text>
				)}
				{props.link && (
					<Anchor
						className={`justify-self-start inline-flex items-center gap-1 text-text-brand transition-colors duration-normal ease-smooth hover:text-text-brand-hover`}
						href={props.link.href}
					>
						<Text styleType='body-md-medium'>{props.link.label}</Text>
						<IconResolver icon='arrow-up-right' className='w-4 h-4' />
					</Anchor>
				)}
			</div>
			<Media className={`aspect-[5/4] rounded-md overflow-hidden [&_img]:h-full max-sm:w-32 lg:max-xl:w-32`} image={props.image} />
		</article>
	);
}
